<div class="app-base">
  <div class="integrated-left">
    <div class="integrated-plan">
      <app-budget-plan> </app-budget-plan>
    </div>

    <app-budget-valorization></app-budget-valorization>
    <!-- <app-integrated-admission-appointment-documentation>
    </app-integrated-admission-appointment-documentation> -->

    <app-budget-observation></app-budget-observation>
  </div>

  <div class="integrated-right">
    <div class="integrated-scann">
      <app-budget-scann></app-budget-scann>
    </div>
  </div>
</div>
